/* eslint-disable @typescript-eslint/no-magic-numbers */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, Tooltip } from 'antd';
import { Block } from 'components/block';
import { InfoCircleIcon, LanguagesGlobeIcon } from 'components/icons';
import { LanguageSkillCell } from 'components/language-skill-cell';
import { EpLanguageSkill } from 'types/graphql-types';
import styles from './styles.less';

type LanguageViewProps = {
  languages: EpLanguageSkill[];
  englishLevel?: string | null;
};

export const LanguageView: FC<LanguageViewProps> = ({
  englishLevel,
  languages,
}) => {
  const { t } = useTranslation('translation');

  const infoCircle = (
    <Tooltip
      title={
        'This section shows the languages from EMS in which the employee experienced.'
      }
    >
      <InfoCircleIcon />
    </Tooltip>
  );

  if (!languages.length && !englishLevel) {
    return (
      <Block title={t('Languages')} subTitle={infoCircle}>
        <LanguagesGlobeIcon className={styles['globe-icon']} />
      </Block>
    );
  }

  const lgSpan = languages.length + 1 >= 4 ? 6 : 8;

  return (
    <Block title={t('Languages')} subTitle={infoCircle}>
      <Row gutter={[16, 16]}>
        {englishLevel && (
          <Col
            key={'ems-english'}
            span={24}
            sm={{ span: 12 }}
            lg={{ span: lgSpan }}
          >
            <LanguageSkillCell name={'English'} level={englishLevel} />
          </Col>
        )}
        {languages.map((language) => {
          const isOld = languages.find((l) => l.name === language.name);

          return (
            <Col
              key={language.name}
              span={24}
              sm={{ span: 12 }}
              lg={{ span: lgSpan }}
            >
              <LanguageSkillCell {...language} glow={!isOld} />
            </Col>
          );
        })}
      </Row>
    </Block>
  );
};
